
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import { parseTaskText } from '@/filters';
import { BModal } from 'bootstrap-vue';
import ConfirmationModal from '@/components/mobile-raise-templates/ConfirmationModal.vue';
import ActionPlansModal from "./ActionPlansModal.vue"
import { ActionPlan } from '@/store/tasks/types';

@Component({
    components: {
        "vue-select": vSelect,
        "vue-perfect-scrollbar": VuePerfectScrollbar,
        "b-modal": BModal,
        "action-plans-modal": ActionPlansModal,
        "confirmation-modal": ConfirmationModal
    },
    filters: {
        parseTaskText
    }
})
export default class ActionPlansOverrideModal extends Vue {

    @Prop({ type: Boolean, default: false })
    private showModal: boolean;

    private isModalShown: boolean = false;
    private isConfirmationModalShown: boolean = false;
    private selectedActionPlan: ActionPlan | null = null;

    @Watch("showModal")
    public onShowModalChanged(): void {
        this.isModalShown = this.showModal;
    }

    @Emit("closeModal")
    private closeModal(): void {
        return;
    }
    
    public actionPlanSelected(actionPlan: ActionPlan): void {
        this.selectedActionPlan = actionPlan;
        this.isModalShown = false;
        this.isConfirmationModalShown = true;
    }

    public confirmActionPlanSelectedClosed(): void {
        this.isConfirmationModalShown = false;
        this.isModalShown = true;
    }

    public confirmActionPlanSelectedConfirmed(): void {
        this.$emit("actionPlanSelected", {...this.selectedActionPlan});
        this.isConfirmationModalShown = false;
        this.selectedActionPlan = null;
    }
}
